module.exports = __webpack_public_path__ + "img/female.77c3c769.svg";